import React from 'react'
import DisplayContacts from './DisplayContacts'
import { Col } from 'react-bootstrap';
import ContactusContext from '../../../contexts/ContactusContext'
import "./viewcontacts.css"

export const ViewContacts = () => {

    let {
        deleteContact,
        contacts,
    } = React.useContext(ContactusContext);

    

  return (
    <Col>
        <DisplayContacts prompts={contacts} onDelete={deleteContact} />
    </Col>
  )
}

export default ViewContacts
